const NullReplacement = () => <span>-</span>;
export default NullReplacement;
